interface ComingSoonProps {
  title: string;
  hint?: string;
}

export default function ComingSoon({ title, hint = 'Coming Soon' }: ComingSoonProps) {
  return (
    <div className="workspace-content">
      <div className="workspace-empty">
        <p className="workspace-empty-title">{title}</p>
        <p className="workspace-empty-hint">{hint}</p>
      </div>
    </div>
  );
}
